import { cleanDoubleSlashes } from '@wkda/funnel-utils';
import pick from 'lodash-es/pick';
import { useCarleadConfiguration } from '../useCarleadCreationConfiguration';
import { useCarleadCjTracking } from '../useCarleadCjTracking';
import { useCarleadDataLayer } from '../useCarleadDataLayer';
export function useStep1BaseProps() {
  const {
    funnelBaseUrl,
    step2Path
  } = useCarleadConfiguration();
  const {
    trackCustomAction
  } = useCarleadCjTracking();
  const dataLayer = useCarleadDataLayer();
  const baseProps = {
    lifecycleHooks: {
      onStepSubmitSuccess: async _ref => {
        let {
          values,
          location,
          stepFields,
          step
        } = _ref;
        dataLayer.add({
          event: `lead.cta.${step + 1}.step`
        });
        await trackCustomAction(`lead.cta.${step + 1}.step`);

        // TODO: refactor and move to a CarleadWizard component
        const stepValues = Array.isArray(stepFields) ? pick(values, stepFields) : values;
        const valuesAsSearchParams = new URLSearchParams(stepValues);
        const currentSearchParams = new URLSearchParams(location.search);
        const valuesAsQuery = valuesAsSearchParams.toString();
        const searchParams = new URLSearchParams({
          ...stepValues,
          ...searchParamsToObject(currentSearchParams)
        }).toString();
        let redirectPath;
        if (typeof step2Path === 'function') {
          redirectPath = step2Path({
            funnelBaseUrl,
            values: stepValues,
            location,
            currentPathName: location.pathname,
            queryParams: searchParams,
            valuesAsQuery
          });
        }
        if (typeof step2Path === 'string') {
          redirectPath = `${pathReplacements(step2Path, {
            currentPath: location.pathname,
            funnelBaseUrl
          })}?${searchParams}`;
        }
        if (!redirectPath) {
          console.error('Redirect path is not defined');
          return;
        }
        window.location.assign(cleanDoubleSlashes(`/${redirectPath}`));
      }
    }
  };
  return baseProps;
}
function searchParamsToObject(searchParams) {
  return Object.fromEntries(searchParams.entries());
}
function pathReplacements(path, replacements) {
  return Object.entries(replacements).reduce((acc, _ref2) => {
    let [key, value] = _ref2;
    return acc.replace(`{${key}}`, value);
  }, path);
}